import React, { useContext, useEffect } from 'react';
import { useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import DehazeIcon from '@material-ui/icons/Dehaze';
import ClearIcon from '@material-ui/icons/Clear';
import {useHistory} from "react-router-dom"
import { Col, Row } from 'reactstrap';
import { NavContext } from '../Context/Context';

const Header=()=>{
    const history=useHistory();
    const {showNav,setShowNav}=useContext(NavContext);
    const isDesktopOrLaptop = useMediaQuery({
        query: '(min-device-width: 1224px)'
      })
      const isTabletOrMobileDevice = useMediaQuery({
        query: '(max-device-width: 1224px)'
      })
      const [showNavg,setshowNavg]=useState(false);
      useEffect(
         ()=>{
             setShowNav(false);},[]
             );
    return(
        <div>
            {
                isDesktopOrLaptop && 
        <nav class="sticky">
            <div class="header">
            <img src={require("../logo2.png")} alt="sj logo" class="logo"/>
            <div style={{float:"right"}}>
                <ul className="main-nav js--main-nav" style={{marginLeft:"20px",float:"right"}}>
                <li><a href="#whytoshop">Why to shop at SJ</a></li>
                    <li><a href="#items">Items</a></li>
                    <li><a href="#aboutus">Contact Us</a></li>
             </ul>       
             </div>

            <div class="section1">
                <h1 style={{color:"#000080",fontSize:"500%",fontFamily: 'Lobster'}}>Siri Jewellers</h1>
                <a class="btn btn-full js--scroll-plans" href='#' onClick={()=>{setShowNav(true); history.push('/signin')}}>SignIn</a>
                <a class="btn btn-ghost js--scroll-more" href='#whytoshop'>Show More</a>
            </div>
        </div>
        </nav>
        }
        
        {
            isTabletOrMobileDevice && 
  <nav class="sticky">

            <div class="header">
            <img src={require("../logo2.png")} alt="sj logo" class="logo" style={{height:"100px"}}/>
            <div style={{float:"right"}}>
                {
                    (showNavg)?(<div >
            <ClearIcon onClick={()=>setshowNavg(!showNavg)} style={{float:"right",fontSize:"40px",marginRight:"20px",marginTop:"20px"}}/>
                        <ul style={{marginTop:"10px",marginRight:"4px",listStyle:"none",fontSize:"20px",textDecoration:"none",display:"inline-block"}}>
                            <li style={{paddingTop:"7px"}}><a href="#whytoshop" style={{color:"white"}} >Why to shop at SJ</a></li>
                            <li style={{paddingTop:"7px"}}><a  href="#items" style={{color:"white"}}>Items</a></li>
                            <li style={{paddingTop:"7px"}}><a href="#aboutus" style={{color:"white"}}>Contact Us</a></li>
                     </ul>       
                     </div>):(<>
            <DehazeIcon onClick={()=>setshowNavg(!showNavg)} style={{float:"right",fontSize:"40px",marginRight:"20px",marginTop:"20px"}}/>
                     </>)
                }
             </div>
            <div class="section1" style={{top:"42%",left:"40%"}}>
                <h3 style={{color:"#000080",fontSize:"350%",marginLeft:"-20px",fontFamily: 'Lobster'}}>Siri Jewellers</h3>
            
            </div>
            <div class="section1" style={{top:"53%",left:"30%",display:"flex"}}>
            <a class="btn btn-full js--scroll-plans" href='#' onClick={()=>{setShowNav(true); history.push('/signin');}}>SignIn</a>    
            <a class="btn btn-ghost js--scroll-more" href='#whytoshop' >Show More</a>
               
            </div>
        </div>
      </nav>
            
        }
        
        </div>
    )
}
export default Header;